import { jwtDecode } from 'jwt-decode';

export class JwtService {
  static decode<T>(token: string | undefined): T | null {
    if (!token) {
      return null;
    }

    try {
      return jwtDecode<T>(token);
    } catch {
      return null;
    }
  }
}
